import React from 'react';
import { useFormikContext, Field } from 'formik';
import dayjs from 'dayjs';

import { InputUI, DatePickerUI, FormErrorUI, AutoCompleteSelectUI, NumberFormatInputUI } from '../../Interface';
import { getJokerFieldType } from '../../../utils/helper';
import { JokerFieldTypes } from '../../../config/joker';

const JokerTab = ({ fields, disabled, variant = 'standard', size = 'medium', onFieldSave }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  return fields.map((field, index) => {
    const f = field.jokerField;

    let fieldType = getJokerFieldType(f);
    //fieldtype alapján létrehozzuk a mezőket
    if (fieldType === JokerFieldTypes.SELECT) {
      return (
        <Field
          key={index}
          name={f.field}
          type={'select'}
          component={AutoCompleteSelectUI}
          fullWidth
          variant={variant}
          size={size}
          label={f.name}
          disabled={disabled}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          dataset={f.valuesToForm}
          onChange={(_e, newVal) => {
            const value = newVal?.value ?? null;

            if (onFieldSave) {
              onFieldSave(f.field, value);
            } else {
              setFieldValue(f.field, value);
            }
          }}
          selectedValue={values[f.field] ?? null}
          selectedLabelValue={f.valuesToForm?.find((p) => p.value === values[f.field])?.label ?? ''}
        />
      );
    } else if (fieldType === JokerFieldTypes.DATE) {
      return (
        <Field
          key={index}
          name={f.field}
          component={DatePickerUI}
          fullWidth
          variant={variant}
          size={size}
          label={f.name}
          disabled={disabled}
          value={values[f.field] ? dayjs(values[f.field]) : null}
          onChange={(newDate) => {
            const value = newDate?.isValid() ? dayjs(newDate).startOf('day').add(12, 'hour').toISOString() : null;

            if (onFieldSave) {
              onFieldSave(f.field, value);
            } else {
              setFieldValue(f.field, value);
            }
          }}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
        />
      );
    } else if (fieldType === JokerFieldTypes.NUMBER) {
      return (
        <Field
          name={f.field}
          as={InputUI}
          fullWidth
          variant={variant}
          size={size}
          label={f.name}
          disabled={disabled}
          InputProps={{
            inputComponent: NumberFormatInputUI,
          }}
          InputLabelProps={{ shrink: values[f.field] !== null && values[f.field]?.toString() !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          {...(onFieldSave && {
            onBlur: () => onFieldSave(f.field, values[f.field]),
          })}
          //onChange={handleChange}
          //{...props}
        />
      );
    } else if (fieldType === JokerFieldTypes.TEXT) {
      return (
        <Field
          name={f.field}
          type="text"
          as={InputUI}
          fullWidth
          variant={variant}
          size={size}
          label={f.name}
          disabled={disabled}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          {...(onFieldSave && {
            onBlur: (e) => onFieldSave(f.field, e.target.value),
          })}
          //onChange={handleChange}
          //{...props}
        />
      );
    }
  });
};

export default JokerTab;
